export default __webpack_public_path__ + "static/media/12.fb71bf26.jpg";